import {actions as A} from '../../../constants/actions';

const showGlobalMessage = (type, message) => {
  return (dispatch) => {
    dispatch({
      type: A.SHOW_GLOBAL_MESSAGE,
      payload: {type, message}
    });
  }

};


export {showGlobalMessage}